module.exports = __webpack_public_path__ + "img/description.6f0bb5b8.svg";